"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
import { ApiWaveOutcomeType } from "@/generated/models/ApiWaveOutcomeType";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
interface WavePodiumItemContentOutcomesProps {
  readonly winner: ApiWaveDecisionWinner;
}
export const WavePodiumItemContentOutcomes: React.FC<WavePodiumItemContentOutcomesProps> = t0 => {
  const $ = _c(30);
  const {
    winner
  } = t0;
  let t1;
  if ($[0] !== winner.awards) {
    t1 = winner.awards.filter(_temp).map(_temp2);
    $[0] = winner.awards;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const memoizedNicOutcomes = t1;
  let t2;
  if ($[2] !== winner.awards) {
    t2 = winner.awards.filter(_temp3).map(_temp4);
    $[2] = winner.awards;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const memoizedRepOutcomes = t2;
  let t3;
  if ($[4] !== winner.awards) {
    t3 = winner.awards.filter(_temp5).map(_temp6);
    $[4] = winner.awards;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const memoizedManualOutcomes = t3;
  const memoizedHaveOutcomes = memoizedNicOutcomes.length > 0 || memoizedRepOutcomes.length > 0 || memoizedManualOutcomes.length > 0;
  let t4;
  if ($[6] !== memoizedHaveOutcomes || $[7] !== memoizedManualOutcomes || $[8] !== memoizedNicOutcomes || $[9] !== memoizedRepOutcomes) {
    t4 = {
      nicOutcomes: memoizedNicOutcomes,
      repOutcomes: memoizedRepOutcomes,
      manualOutcomes: memoizedManualOutcomes,
      haveOutcomes: memoizedHaveOutcomes
    };
    $[6] = memoizedHaveOutcomes;
    $[7] = memoizedManualOutcomes;
    $[8] = memoizedNicOutcomes;
    $[9] = memoizedRepOutcomes;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    nicOutcomes,
    repOutcomes,
    manualOutcomes,
    haveOutcomes
  } = t4;
  if (!haveOutcomes) {
    return null;
  }
  const tooltipId = `outcome-${winner.place}-${winner.drop.id}`;
  let t5;
  if ($[11] !== nicOutcomes) {
    t5 = nicOutcomes.map(_temp7);
    $[11] = nicOutcomes;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== repOutcomes) {
    t6 = repOutcomes.map(_temp8);
    $[13] = repOutcomes;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== manualOutcomes) {
    t7 = manualOutcomes.map(_temp9);
    $[15] = manualOutcomes;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="tw-flex tw-min-w-[180px] tw-flex-col tw-gap-y-1.5 tw-py-0.5">{t5}{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const tooltipContent = t8;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-text-sm tw-font-medium tw-text-iron-300">Outcome</span>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== tooltipId) {
    t10 = <button type="button" className="tw-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-solid tw-border-iron-700/20 tw-bg-iron-800/40 tw-px-3 tw-py-1.5 tw-backdrop-blur-sm tw-transition-all tw-duration-200 hover:tw-border-iron-700/40 hover:tw-bg-iron-800/60 hover:tw-shadow-lg" data-tooltip-id={tooltipId}>{t9}</button>;
    $[22] = tooltipId;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== tooltipContent || $[25] !== tooltipId) {
    t11 = <Tooltip id={tooltipId} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{tooltipContent}</Tooltip>;
    $[24] = tooltipContent;
    $[25] = tooltipId;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
function _temp(award) {
  const amount = award.amount ?? 0;
  return award.credit === ApiWaveOutcomeCredit.Cic && amount > 0;
}
function _temp2(award_0) {
  return {
    type: ApiWaveOutcomeCredit.Cic,
    value: award_0.amount ?? 0
  };
}
function _temp3(award_1) {
  const amount_0 = award_1.amount ?? 0;
  return award_1.credit === ApiWaveOutcomeCredit.Rep && amount_0 > 0;
}
function _temp4(award_2) {
  return {
    type: ApiWaveOutcomeCredit.Rep,
    value: award_2.amount ?? 0,
    category: award_2.rep_category ?? ""
  };
}
function _temp5(award_3) {
  const description = award_3.description;
  return award_3.type === ApiWaveOutcomeType.Manual && description.length > 0;
}
function _temp6(award_4) {
  return {
    type: ApiWaveOutcomeType.Manual,
    description: award_4.description
  };
}
function _temp7(nicOutcome) {
  return <div key={`NIC-${nicOutcome.value}`} className="tw-flex tw-items-center tw-gap-x-1.5"><span className="tw-font-medium tw-text-iron-50">NIC</span><span className="tw-text-blue-200/90">{formatNumberWithCommas(nicOutcome.value)}</span></div>;
}
function _temp8(repOutcome) {
  return <div key={`REP-${repOutcome.category}-${repOutcome.value}`} className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-0.5"><span className="tw-font-medium tw-text-iron-50">Rep</span><span className="tw-text-purple-200/90">{formatNumberWithCommas(repOutcome.value)}</span>{repOutcome.category.length > 0 && <><span className="tw-size-[2px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-300/70" /><span className="tw-text-purple-200/90">{repOutcome.category}</span></>}</div>;
}
function _temp9(outcome) {
  return <div key={`MANUAL-${outcome.description}`} className="tw-flex tw-items-center tw-gap-x-1.5"><span className="tw-text-amber-100/90">{outcome.description}</span></div>;
}